import { action, computed, observable } from 'mobx';

import { TEMPTED_SUBSCRIPTION_PRICE_FOR_ANCHOR } from '../constants/apiUrls/apiUrls';
import * as FanclubPackageServices from '../services/FanclubPackageServices';
import callApi from '../utils/callApi';
import { returnCorrectProduct } from '../utils/PriceValidator';


class FanclubPackageStore {
  @observable fanclubPackage = null;

  @computed get fanclubPackagePrice() {
    return this.fanclubPackage ? this.fanclubPackage : '';
  }

  @action async getFanclubSubscriptionPackage(anchorId) {
    const { error, data } = await FanclubPackageServices.getFanclubSubscriptionPackage(anchorId);
    const URL = TEMPTED_SUBSCRIPTION_PRICE_FOR_ANCHOR.replace('{anchorId}', encodeURIComponent(anchorId));

    callApi(URL, 'get').then((res) => {
      const priceDetails = returnCorrectProduct(data, res.data.price);
      if (priceDetails.fee) {
        this.fanclubPackage = priceDetails.priceInfo[0].details.recurringAmount;
      } else {
        this.fanclubPackage = priceDetails.priceInfo[0].details.recurringAmount || priceDetails.priceInfo[0].amount;
      }
    }).catch((err) => {
      if (err) {
        this.fanclubPackage = '';
      }
    });
  }
}

export default new FanclubPackageStore();
